var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bkf-action',{attrs:{"tooltip":_vm.$trans(_vm.value ? 'action-button.shrink' : 'action-button.expand')},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("\n    "+_vm._s(_vm.value ? 'fullscreen_exit' : 'fullscreen')+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }